import type { ShapeType } from "@/pages/canvas/nodes/shapes/index";
import {
  Circle,
  Cylinder,
  Diamond,
  Pentagon,
  Square,
  Triangle,
  type LucideIcon,
} from "lucide-react";

/** Standard 16×16 glyph slot for every canvas toolbar button icon. */
export const canvasToolbarIconClassName = "size-4 shrink-0";

/** Toolbar glyph per shape — shared by the shapes flyout and the primary
 * bar's Shapes trigger, which wears the last-picked shape. */
export const SHAPE_LUCIDE_ICON: Record<ShapeType, LucideIcon> = {
  rectangle: Square,
  circle: Circle,
  diamond: Diamond,
  triangle: Triangle,
  pentagon: Pentagon,
  cylinder: Cylinder,
};
